import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './index.css';
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { lightTheme } from './lightTheme';
import Auth0ProviderWithNavigate from './Auth0ProviderWithNavigate';
import { BrowserRouter } from 'react-router-dom';
import GoogleTagManager from './common/GoogleTagManager';
import config from './config';

GoogleTagManager.init(config.GTM_ID);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={lightTheme}>
          <CssBaseline />
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
